import Cookie from "js-cookie";

export const newsletterPopup = function (el) {
    const showPopupAfterMiliseconds = el.getAttribute("data-timeout") * 1000;
    const hideForDays = el.getAttribute("data-days");
    if (!Cookie.get("sessionStart") && !Cookie.get("popupShown")) {
        const now = new Date().getTime();
        Cookie.set("sessionStart", now, { expires: 1 });
        setTimeout(function () {
            showPopup(hideForDays);
        }, showPopupAfterMiliseconds);
    } else if (Cookie.get("sessionStart") && !Cookie.get("popupShown")) {
        const passedMiliseconds =
            new Date().getTime() - Cookie.get("sessionStart");
        if (passedMiliseconds > showPopupAfterMiliseconds) {
            showPopup(hideForDays);
        } else {
            setTimeout(function () {
                showPopup(hideForDays);
            }, showPopupAfterMiliseconds - passedMiliseconds);
        }
    }
};

const showPopup = function (hideForDays) {
    document.querySelector(".cta--fixed").classList.remove("cta--hidden");
    Cookie.set("popupShown", true, { expires: parseInt(hideForDays) });
};

export const newsletterClose = function (el) {
    document.querySelector(".cta--fixed").classList.add("cta--hidden");
};
